









































import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'c-statistic-toolbar'
})
export default class StatisticToolbar extends Vue {
  currentPage: string = 'StatCollectedData'
  pages: string[] = ['StatCollectedData', 'StatSurveys', 'StatStandmans']
  selectedPage: string = ''

  protected selectMenu (e: any) {
    this.currentPage = e.target.value
    this.$router.push({ name: e.target.value }).catch(() => {})
  }

  updateData() {
    this.$emit('update-data')
    this.$store.state.statistics.isUpdated = true
  }

  beforeMount() {
    this.currentPage = this.pages.find(item => item === this.$route.name) as string
  }
}
